/** Rasterize a code-generated SVG once, retaining a canvas for device recovery.
 * Explicit dimensions avoid browser SVG sizing differences. No external assets. */
export async function paintedPage(svg:string,aspect:number):Promise<HTMLCanvasElement>{
 const height=Math.round(Math.min(1200,1536/Math.max(1,aspect))),width=Math.round(height*aspect);
 const url=URL.createObjectURL(new Blob([svg],{type:'image/svg+xml'}));
 try{
  const img=new Image();img.src=url;await img.decode();
  const canvas=document.createElement('canvas');canvas.width=width;canvas.height=height;
  const context=canvas.getContext('2d');if(!context)throw new Error('No illustration surface');
  context.drawImage(img,0,0,width,height);return canvas;
 }finally{URL.revokeObjectURL(url);}
}
